<h1 mat-dialog-title>Enter a value for each row</h1>

<section mat-dialog-content>
  <div class="flex h-[100px] items-center justify-center">
    <numeric-input-field [max]="24" [control]="control" />
  </div>
</section>

<section mat-dialog-actions>
  <button mat-raised-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="enter()">Enter</button>
</section>
